import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import { Icon } from 'ui';
import SessionDetail from './SessionDetail';

const Header = ({ event, session }) => {
  const formattedDate = moment(session.start_time).format(DateFormat.LONG);
  const formattedStartTime = moment(
    session.start_time,
    DateFormat.fixed.ISO8601_LOCAL,
  ).format(DateFormat.TIME);
  const formattedTimeZone = session.time_zone.formatted;

  return (
    <div className="EventSessionOverview-header">
      <a
        className="c-brand-blue"
        href={routes.IN_PERSON_TRAINING.EVENT(event.id)}
      >
        <Icon name="back" className="mr-8" />
        {t('in_person_training.session.back_to_event_overview')}
      </a>
      <h1 className="ff-ss mt-32">{event.name}</h1>
      <div className="mt-16">
        {formattedDate}
        <span className="mr-8 ml-8 c-gray-light">|</span>
        {formattedStartTime}
        &nbsp;
        {formattedTimeZone}
      </div>
      <div>
        <SessionDetail value={session.location} label={t('common.location')} />
        <SessionDetail
          value={session.trainer.name}
          label={t('common.instructor')}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  event: state.event,
  session: state.session,
});

export default connect(mapStateToProps)(Header);
